import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { ExtensionDetailLinkComponent } from './extension-detail-link/extension-detail-link.component';
import { ExtensionGroupDetailLinkComponent } from './extension-group-link/extension-group-detail-link.component';
import { PhoneNumberDetailLinkComponent } from './phone-number-detail-link/phone-number-detail-link.component';

@NgModule({
   declarations: [ExtensionDetailLinkComponent, PhoneNumberDetailLinkComponent, ExtensionGroupDetailLinkComponent],
   exports: [ExtensionDetailLinkComponent, PhoneNumberDetailLinkComponent, ExtensionGroupDetailLinkComponent],
   imports: [CommonModule, RouterModule, FormatPhoneNumbersPipeModule],
})
export class DetailLinksModule {}
